import * as React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { Box, Grid } from "@mui/material"


const iconsInfo = [{
    icon: 'chart-fft',
    title: 'First Mover: ',
    text: 'First product to change price compared to the rest'
}, {
    icon: 'arrows-repeat',
    title: 'Restocked: ',
    text: 'Product that was out of stock and is now in stock'
}, {
    icon: 'arrow-right-from-bracket',
    title: 'Out of Stock: ',
    text: 'Product that was in stock and is now out of stock.'
}, {
    icon: 'trophy',
    title: 'Most Competitive Pricing: ',
    text: 'The retailer who has been the most frequent lowest price holder.'
}]

export default function MonitoringResultsFooterInfo() {

    return <Grid container sx={{ width: .7, ml: 4 }} alignItems="top">
        <Grid item xs={12}>
            <Box sx={{ display: 'flex', mb: 2 }}>
                <IconSeeker icon="info-circle" iconType="fontAwesome" size="medium" iconWeight="regular" sx={{ fontSize: '3rem', mr: 1, mt: -0.5 }}/>
                <Box sx={{ fontWeight: 'bold', fontSize: '1.5rem', pb: 1 }}>Icon Status Info</Box>
            </Box>
            { iconsInfo.map(( item, idx ) => <Box key={idx} sx={{ pl: 2, mt: 1 }}>
                <IconSeeker icon={item.icon} sx={{  mr: 1, ...(item.color && { color: item.color }) }} />
                <Box component="span" sx={{ ml: 2, verticalAlign: 'middle' }}>
                    <Box component="span" sx={{ fontWeight: 'bold' }}>{item.title}</Box>
                    {item.text}
                </Box>
            </Box>) }
        </Grid>
    </Grid>
}